// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__uD8_K"};